import ModelService from './ModelService';
const modelService = new ModelService();

const model = 'email-logs';

export async function IndexLogs(type) {
  return modelService.IndexModel(`${model}?type=${type}`);
}
